import {gql} from '@apollo/client/core';
import {CustomerProfileAddressFragment} from './checkout.fragment';

export const CustomerProfileFragment = gql`
  fragment customerProfile on CustomerProfile {
    id
    emailForOrderConfirmation
    fullName
    superpayUUID
    phoneNumber
    isEmailConfirmed
    hasPassword
    accountType
    ageVerificationStatus
    ageVerificationId
    creditAmount
    creditBalance
    creditConditions
    deliveryComment
    dob
    cvr
    ean
    invoiceEmail
    vismaId
    companyName
    limitedToGroupVoucher
    groupVoucherCode
    reviews {
      rating
      product {
        id
        vismaProductNumber
      }
    }
    wishlist {
      id
      vismaProductNumber
    }
    addresses {
      ...customerProfileAddress
    }
  }
  ${CustomerProfileAddressFragment}
`;
